module.exports = __webpack_public_path__ + "static/media/btn_fire_log_1075_725.f08645bf.png";